<template lang="pug">
#bloco-dados-gerais-territorio-monitoramento.view-container
    .dados-gerais-territorio-monitoramento__container
        h3 Situação do Território
        .dados-gerais-territorio-monitoramento__lista
            .dados-gerais-territorio-monitoramento__lista-item(
                v-for='(situacao, index) in territorioSituacaoCamadaCategoria',
                :key='index'
            )
                BlocoSituacaoTerritorio(
                    :titulo='situacao.camadaCategoria.nome',
                    :disabled='(situacao.diagnosticos == null || situacao.diagnosticos.length === 0) && (situacao.diagnosticoPorRepresentante == null || situacao.diagnosticoPorRepresentante.length === 0)',
                    subTitulo='Não conformidades:',
                    :valor='situacao.qtdeNaoConformidade',
                    @click.native='exibirModalVisualizarInformacaoTerritorioMonitoramento(situacao)'
                )

    ModalVisualizarInformacaoTerritorioMonitoramento(
        :situacao='situacao',
        :cars='diagnosticosCars',
        :territorio='territorio',
        :show='showModalVisualizarInformacaoTerritorioMonitoramento',
        @close='closeModalVisualizarInformacaoTerritorioMonitoramento'
    )
</template>

<script>
import BlocoSituacaoTerritorio from '@/components/monitoramento/BlocoSituacaoTerritorio';
import ModalVisualizarInformacaoTerritorioMonitoramento from '@/components/monitoramento/ModalVisualizarInformacaoTerritorioMonitoramento';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import CamadasCategorias from '@/utils/camadasCategorias';

export default {
    name: 'BlocoDadosGeraisTerritorioMonitoramento',
    components: {
        BlocoSituacaoTerritorio,
        ModalVisualizarInformacaoTerritorioMonitoramento
    },
    props: {
        monitoramento: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            territorio: {},
            carsVinculados: [],
            showModalVisualizarInformacaoTerritorioMonitoramento: false,
            territorioSituacaoCamadaCategoria: [],
            carsSituacaoCamadaCategoria: [],
            situacao: {},
            diagnosticosCars: {}
        };
    },
    mounted() {
        this.territorio = this.monitoramento.territorio;
        this.carsVinculados = this.monitoramento.carsApi;
        this.buscarSituacaoTerritorio();
        this.buscarSituacaoCARsVinculados();
    },

    methods: {
        closeModalVisualizarInformacaoTerritorioMonitoramento() {
            this.showModalVisualizarInformacaoTerritorioMonitoramento = false;
        },
        exibirModalVisualizarInformacaoTerritorioMonitoramento(situacao) {
            if (
                (situacao.diagnosticos == null ||
                    situacao.diagnosticos.length === 0) &&
                (situacao.diagnosticoPorRepresentante == null ||
                    situacao.diagnosticoPorRepresentante.length === 0)
            ) {
                return;
            }

            this.situacao = {
                ...situacao,
                diagnosticos: situacao.diagnosticos.map(d => ({
                    ...d,
                    camada: { ...d.camada, opacidade: 100 },
                    nivelAlerta: d.nivelAlerta,
                    status: d.status
                }))
            };

            this.diagnosticosCars = this.filtrarCarsPelaSituacao(
                situacao.camadaCategoria.id
            );

            this.showModalVisualizarInformacaoTerritorioMonitoramento = true;
        },
        buscarSituacaoTerritorio() {
            const filtro = {
                idDiagnostico: this.monitoramento.diagnosticoSocioambiental.id,
                idsCategoria: CamadasCategorias.filter(cc =>
                    [
                        'EMBARGOS_DESMATAMENTO',
                        'SOCIAL',
                        'AREAS_PROTEGIDAS',
                        'REPRESENTANTES'
                    ].includes(cc.codigo)
                ).map(cc => cc.id)
            };

            MonitoramentoSocioambientalService.buscarSituacaoCamadaCategoria(
                filtro
            )
                .then(({ data }) => {
                    data.situacoesCamadaCategoria.forEach(situacao => {
                        if (
                            situacao.camadaCategoria.codigo.includes(
                                'REPRESENTANTES'
                            )
                        ) {
                            situacao.camadaCategoria.nome = 'Pessoas';
                        }

                        situacao.diagnosticos.sort((a, b) => {
                            return a.camada.nome.localeCompare(b.camada.nome);
                        });

                        Object.keys(situacao.diagnosticos).forEach(item => {
                            if (
                                situacao.diagnosticos[item].camada.nome ===
                                'Áreas embargadas'
                            ) {
                                situacao.diagnosticos[item].camada.nome =
                                    'Áreas embargadas (IBAMA)';
                            } else if (
                                situacao.diagnosticos[item].camada.nome ===
                                'Monitoramento Desmatamento'
                            ) {
                                situacao.diagnosticos[item].camada.nome =
                                    'Desmatamento Lyra';
                            }
                        });

                        Object.keys(
                            situacao.diagnosticoPorRepresentante
                        ).forEach(itemRepresentante => {
                            Object.keys(
                                situacao.diagnosticoPorRepresentante[
                                    itemRepresentante
                                ].diagnostico
                            ).forEach(i => {
                                if (
                                    situacao.diagnosticoPorRepresentante[
                                        itemRepresentante
                                    ].diagnostico[i].camada.nome ===
                                    'Áreas embargadas'
                                ) {
                                    situacao.diagnosticoPorRepresentante[
                                        itemRepresentante
                                    ].diagnostico[i].camada.nome =
                                        'Áreas embargadas (IBAMA)';
                                } else if (
                                    situacao.diagnosticoPorRepresentante[
                                        itemRepresentante
                                    ].diagnostico[i].camada.nome ===
                                    'Monitoramento Desmatamento'
                                ) {
                                    situacao.diagnosticoPorRepresentante[
                                        itemRepresentante
                                    ].diagnostico[i].camada.nome =
                                        'Desmatamento Lyra';
                                }
                            });
                        });
                    });
                    this.territorioSituacaoCamadaCategoria =
                        data.situacoesCamadaCategoria;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar os dados da área monitorada'
                    });
                });
        },

        buscarSituacaoCARsVinculados() {
            if (this.carsVinculados) {
                this.carsVinculados.forEach(car => {
                    let filtro = {
                        car: car.codigo,
                        idsCategoria: CamadasCategorias.filter(cc =>
                            [
                                'EMBARGOS_DESMATAMENTO',
                                'SOCIAL',
                                'AREAS_PROTEGIDAS'
                            ].includes(cc.codigo)
                        ).map(cc => cc.id)
                    };

                    MonitoramentoSocioambientalService.buscarSituacaoPorCar(
                        filtro
                    )
                        .then(({ data }) => {
                            data.situacoesCamadaCategoria.forEach(situacao => {
                                situacao.diagnosticos.sort((a, b) => {
                                    return a.camada.nome.localeCompare(
                                        b.camada.nome
                                    );
                                });

                                Object.keys(situacao.diagnosticos).forEach(
                                    item => {
                                        if (
                                            situacao.diagnosticos[item].camada
                                                .nome === 'Áreas embargadas'
                                        ) {
                                            situacao.diagnosticos[
                                                item
                                            ].camada.nome =
                                                'Áreas embargadas (IBAMA)';
                                        } else if (
                                            situacao.diagnosticos[item].camada
                                                .nome ===
                                            'Monitoramento Desmatamento'
                                        ) {
                                            situacao.diagnosticos[
                                                item
                                            ].camada.nome = 'Desmatamento Lyra';
                                        }
                                    }
                                );
                            });
                            const situacao = {
                                car: car,
                                situacoes: data.situacoesCamadaCategoria
                            };
                            this.carsSituacaoCamadaCategoria.push(situacao);
                        })
                        .catch(e => {
                            this.$notify.error({
                                message:
                                    'Ocorreu um erro ao buscar os dados do CAR vinculado.'
                            });
                        });
                });
            }
        },
        filtrarCarsPelaSituacao(id) {
            let retorno = { cars: [], qtdeNaoConformidade: 0 };
            this.carsSituacaoCamadaCategoria.forEach(car => {
                const situacao = car.situacoes.filter(
                    situacao => situacao.camadaCategoria.id === id
                )[0];
                if (situacao) {
                    retorno.cars.push({
                        codigo: car.car.codigo,
                        condicao: car.car.condicao,
                        geometria: car.car.geometria,
                        situacao: situacao
                    });
                    retorno.qtdeNaoConformidade += situacao.qtdeNaoConformidade;
                }
            });

            return retorno;
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-dados-gerais-territorio-monitoramento {
    .dados-gerais-territorio-monitoramento__container {
        margin-top: 18px;

        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }

        .dados-gerais-territorio-monitoramento__lista {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .dados-gerais-territorio-monitoramento__lista-item {
                width: 24.25%;
                margin: 2px 10px 2px 0px;

                &:last-child {
                    margin: 2px 0px;
                }
            }
        }
    }
}
</style>
